import { MessageEnvelope, MessageType, textSchema } from '@zonofi/common';
import { ExtractedMessageProperties } from '../types';

export const extractMessageProperties = (
  envelope: MessageEnvelope
): ExtractedMessageProperties => {
  const { message, channel: channelId, actions } = envelope || {};
  const {
    template: originalTemplate = {},
    text: msgText = '',
    data,
    type: mType,
    media = [],
    inviteId,
    sType,
    intent,
    fileUrl,
    formAnswerId,
    formId,
  } = message || {};

  const messageUpdated = actions?.['updated'] || {};
  const editedText = Object.keys(messageUpdated)?.[0];

  const finalText = editedText ?? msgText ?? '';

  return {
    originalTemplate,
    text: textSchema.safeParse(finalText).success ? finalText : '',
    data: data as any,
    type:
      (mType === MessageType.TYPEBOT
        ? intent
        : mType === MessageType.ISSUE
          ? sType || mType
          : mType) || MessageType.TEXT,
    media: media ?? [],
    inviteId,
    fileUrl,
    formAnswerId,
    formId,
    channelId,
    actions,
  };
};
